import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ScannerTrialReminder } from "./ScannerTrialReminder.component";
import {ScannerTrialReminderMobile} from "../ScannerTrialReminderMobile/ScannerTrialReminderMobile.component";





export function showScannerTrialReminderModal(modalService: NgbModal, mobileMode: string = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component =  mobile? ScannerTrialReminderMobile: ScannerTrialReminder;
    const windowClass = "dark-modal slargeWindow" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "lg",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<ScannerTrialReminder>m.componentInstance);
    return modal;
}
